export interface SessionProjectTransition {
  previousProjectId: string | null;
  nextProjectId: string | null;
  sessionId: string | null;
  sessionProjectId: string | null;
  creatingSessionProjectId: string | null;
}

/**
 * Project changes normally invalidate the active chat. The exception is a session
 * that already belongs to, or is currently being created for, the next project.
 */
export function shouldClearSessionForProjectTransition(
  transition: SessionProjectTransition
): boolean {
  if (!transition.previousProjectId || transition.previousProjectId === transition.nextProjectId) {
    return false;
  }

  const loadedSessionMatchesNextProject = Boolean(
    transition.sessionId &&
      transition.nextProjectId &&
      transition.sessionProjectId === transition.nextProjectId
  );
  if (loadedSessionMatchesNextProject) return false;

  const pendingSessionMatchesNextProject = Boolean(
    transition.nextProjectId && transition.creatingSessionProjectId === transition.nextProjectId
  );
  return !pendingSessionMatchesNextProject;
}
